import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { LocalStorageRefService } from "./local-storage-ref.service";

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    private localStorage: Storage;

    constructor(private localStorageRefService: LocalStorageRefService) {
        this.localStorage = localStorageRefService.localStorage;
    }



    clearAllLocalStorage() {
        this.localStorage.clear();
    }
}